import Vue from 'vue'
import router from './index'
import {
	Message
} from 'element-ui'
import {
	getCookie
} from '@/utils/cookie'
import store from '@/store'
import getMeus from '@/router/getMeus'
import routingList from '@/router/routingList.js' //路由列表

// 路由前置守卫
let hasMenus = false
router.beforeEach((to, from, next) => {
	//拿取用户权限标识是否存在
	let userPermissionsFlag = !store.state.app.user_permissions && (sessionStorage.getItem('user_permissions') && !JSON.parse(sessionStorage.getItem('user_permissions')))
	if (getCookie('access_token')) {
		// 已登录
		if (hasMenus && to.matched.length === 0) {
			//判断是否存在页面
			Message.error('不存在该页面或无权限访问')
			next(from.path)
		} else if (hasMenus) {
			if (to.path === '/login' || to.path === '/') { //去的页面是登录页面直接跳转到主页
				next({
					path: '/home'
				})
			} else {
				next()
			}
		} else if (userPermissionsFlag || userPermissionsFlag == null) {
			store.dispatch('deleteLoginStatus') //无权限，退出登录
		} else {
			let routesArr = getList()
			router.addRoutes(routesArr)
			hasMenus = true //将菜单标志设置为true
			next({
				path: to.fullPath || '/home'
			})
		}
	} else {
		//未登录
		hasMenus = false
		if (to.path === '/login') {
			next()
		} else {
			next({path:'/login'})
		}
		store.commit('DELETE_TOKEN')//清除token
		sessionStorage.removeItem('user_permissions') //删除当前用户权限缓存
		sessionStorage.removeItem('editableTabs') //删除标签页缓存
		sessionStorage.removeItem('editableTabsValue') //删除当前选择标签页缓存
	}
})

// 路由后置守卫
router.afterEach(to => {
	store.commit('SET_ACTIVE_INDEX', to.path)
})


//获取用户路由列表
function getList() {
	//获取用户权限id列表
	let user_permissions = store.state.app.user_permissions || (sessionStorage.getItem('user_permissions') && JSON.parse(sessionStorage.getItem('user_permissions')))
	//获取用户权限树列表
	let user_permissions_list = []
	if (user_permissions && user_permissions.length) {
		user_permissions_list = getMeus(user_permissions, 2) //获取当前用户权限列表
	}
	let routesList = []
	//遍历路由与用户权限树相匹配，获得用户路由列表
	for (let i = 0, len = user_permissions_list.length; i < len; i++) {
		for (let j = 0, len1 = routingList.length; j < len1; j++) {
			if (user_permissions_list[i].name === routingList[j].name && !routesList.includes(routingList[j])) {
				routesList.push(routingList[j])
			}
		}
	}
	return [{
		path: '/',
		name: 'layout',
		meta: {
			title: '主页面',
		},
		component: () => import('../views/Layout.vue'),
		children: routesList
	}, ]
}
